import { env } from '@sib/config';
import mixpanel from 'mixpanel-browser';
import { EventType } from './types';

const isTrackingEnabled = !!env.mixpanelProjectToken;

const init = () => {
  if (isTrackingEnabled)
    mixpanel.init(env.mixpanelProjectToken, {
      persistence: 'localStorage',
      record_idle_timeout_ms: 600000,
      record_mask_text_selector: '',
      record_block_selector: 'img, video, iframe',
    });
};

interface SetUserPayload {
  name: string;
  email: string;
}

interface SetUserOptions {
  omitLastLogin?: boolean;
}

const setUser = ({ email, name }: SetUserPayload, options?: SetUserOptions) => {
  if (!isTrackingEnabled) return;
  mixpanel.identify(email);
  mixpanel.people.set({
    $name: name,
    $email: email,
    ...(!options?.omitLastLogin && {
      $last_login: new Date(),
    }),
  });
};

const isUserIdentified = (email?: string) =>
  mixpanel.get_distinct_id() === email;

const identifyUser = (email?: string, name?: string) => {
  if (!email || isUserIdentified(email)) return;

  setUser({ email, name: name || '' });
};

const track = (event: EventType, payload?: object) =>
  isTrackingEnabled &&
  mixpanel.track(event, {
    ...payload,
    environment: env.environment,
  });

const startSessionRecording = () => {
  const properties = mixpanel.get_session_recording_properties();
  const isRecording = Object.entries(properties).length > 0;

  if (!isRecording) mixpanel.start_session_recording();
};

export default {
  init,
  setUser,
  track,
  startSessionRecording,
  identifyUser,
};
